export default "__VITE_ASSET__De1wxAJk__"